<div class="container" >

                <foo-details></foo-details>
                <ngx-spinner size="medium" [type]="typeSelected"></ngx-spinner>
            </div>